import React from 'react';
import classNames from 'classnames';
import { HORIZONTAL_LINE_NAME } from '../../constants/analyticsNames';
import { HORIZONTAL_LINE } from '../../constants/cmsResourceTypes';
import styles from '../../components/HorizontalLine/index.module.scss';
const HorizontalLine = ({ breakpointClasses }) => (React.createElement("section", { className: classNames(styles.horizontalLineWrapper, breakpointClasses) },
    React.createElement("div", { className: styles.horizontalLine })));
HorizontalLine.displayName = HORIZONTAL_LINE_NAME;
HorizontalLine.resourceType = HORIZONTAL_LINE;
export default HorizontalLine;
//# sourceMappingURL=index.js.map